import { useAtomValue } from 'jotai';

import Item from './item';

import { modeState, vendorPlacesQuery } from '../../../../../../store';

import type { Place } from '@rewardopl/types';

type ItemsProps = {
  selectedPlaceId: Place['_id'] | null;
  setSelectedPlaceId: React.Dispatch<React.SetStateAction<Place['_id'] | null>>;
};

export default function Items({ selectedPlaceId, setSelectedPlaceId }: ItemsProps) {
  const places = useAtomValue(
    vendorPlacesQuery({
      includePlacesWithoutLocation: true,
    }),
  );
  const mode = useAtomValue(modeState);

  const filteredBusinessPlaces = places.filter((place) =>
    mode === 'bubblejoy' ? !place.is_bubblejoy_taiwan : place.is_bubblejoy_taiwan,
  );

  if (!filteredBusinessPlaces.length) {
    return null;
  }

  return filteredBusinessPlaces.map((place) => (
    <Item
      isSelected={place._id === selectedPlaceId}
      key={place._id}
      onClick={() => setSelectedPlaceId(place._id)}
      place={place}
    />
  ));
}
